// extracted by mini-css-extract-plugin
export default {"container":"CommonFileView_container__QU62W","icon":"CommonFileView_icon__DqyC7","content":"CommonFileView_content__uzz9p"};